import { InjectionToken } from '@angular/core';
import { IntegratorTracker } from '@wheere/api-tracker';
import { Observable } from 'rxjs';

export type CommandResultKind = 'site' | 'device' | 'gateway' | 'org';

/** Recherche d'appareils de la palette : texte saisi, scope d'org (plateforme), taille du groupe. */
export interface CommandDeviceQuery {
  search: string;
  organizationId?: string;
  size: number;
}

/**
 * Configuration de la palette, fournie par chaque application qui la monte (`app.config.ts`).
 * Pas de valeur par défaut : une app qui monte `<wh-command-palette>` sans dire ce que
 * l'utilisateur a le droit d'ouvrir échoue au démarrage plutôt que de tout montrer.
 */
export interface CommandPaletteConfig {
  /**
   * Types de résultat que l'utilisateur courant peut ouvrir — même règle que les gardes des routes
   * de l'app (`/sites/:id`, `/devices/:id`, `/gateways/:id`). Relu à chaque recherche (rôles
   * chargés après le démarrage). Un type absent n'est ni interrogé ni affiché.
   */
  allowedKinds(): readonly CommandResultKind[];
  /**
   * Source des appareils. Absente : `GET /integrator/trackers` du client généré, tous les `kind`
   * (inside, baromètres compris). L'intégrateur la fournit pour n'avoir que `kind=TRACKER`.
   */
  searchDevices?(query: CommandDeviceQuery): Observable<IntegratorTracker[]> | Promise<IntegratorTracker[]>;
  /**
   * Route de la fiche d'un appareil. Absente : `/devices/:id` (intégrateur). Inside la fournit :
   * sa fiche vit sous `/devices/trackers/:id`.
   */
  deviceRoute?(id: string): unknown[];
}

export const COMMAND_PALETTE_CONFIG = new InjectionToken<CommandPaletteConfig>('Command palette config');
